<script>
import Dexie from 'dexie';
import { marked } from 'marked';
import { markedHighlight } from 'marked-highlight';
import hljs from 'highlight.js';
import moment from "moment";
import 'highlight.js/styles/github.css';
import * as CryptoJS from 'crypto-js';
import { v4 as uuid } from 'uuid';

export default {
  name: "index",
  data() {
    return {
      dbClient: null,
      btnDisabled: false,
      inputValue: '',
      chatList: [],
      sessionId: '',
      language: 'zh-CN',
      timeFlag: null,
      interactiveFlag: false,
      interactiveTime: null,
      userInfo: {},
      getH5MessageTimeId: null,
      agentFlag: false,
      h5BtnDisable: false,
    }
  },
  created() {
    this.dbClient = new Dexie('H5_GPT_DATA_HE_TU');
    this.dbClient.version(1).stores({
      MessageList: '++id,sessionId,bot,content,time',
    });
    this.initMarkedOptions();
    this.getChatListFromIndexDB();
    this.language = window.navigator.language || window.navigator.userLanguage;
    this.getUrlInfo();
  },
  mounted() {
    this.timeFlag = setInterval(() => {
      this.refreshTime();
    }, 1000*60)
    this.getH5MessageTimeId = setInterval(() => {
      this.getChatH5Message();
    }, 1000);
    window.document.querySelector('.he-tu-h5-chat-outer').addEventListener('click', this.hrefClickFn, true)
  },
  beforeDestroy() {
    if (this.timeFlag) {
      clearInterval(this.timeFlag);
    }
    if (this.getH5MessageTimeId) {
      clearInterval(this.getH5MessageTimeId);
    }
    window.document.querySelector('.he-tu-h5-chat-outer').removeEventListener('click', this.hrefClickFn);
  },
  methods: {
    hrefClickFn(e) {
      if (e.target.tagName === 'A') {
        e.preventDefault();
        window.open(e.target.href, '_blank');
      }
    },
    scrollToBottom() {
      const container = this.$refs.scrollContainer;
      container.scrollTop = container.scrollHeight;
    },
    getUrlInfo() {
      this.userInfo = this.$route.query || {};
    },
    randomDeviceId() {
      return 'device_' + Date.now() + Math.random().toString(36).substring(2)
    },
    async getChatH5Message() {
      const scopeId = this.$options._scopeId;
      const messageBody = JSON.stringify({
        to: this.sessionId,
      })
      const header = await this.getHeaders(messageBody);
      fetch('/a2p/api/v1/chatbot-h5/outbound/query', {
        method: 'POST',
        body: messageBody,
        headers: header
      })
        .then(res => {
          return res.json()
        })
        .then(res => {
          this.agentFlag = res.hasAgentSession;
          if (res && res.messageList && res.messageList.length) {
            // 有消息推送过来了
            res.messageList.forEach(item => {
              if (item.text) {
                const h5BotInfo = {
                  sendTime: moment.parseZone(item.sendTime).format('YYYY-MM-DD HH:mm:ss'),
                  sessionId: this.sessionId,
                  bot: true,
                  content: item.text
                }
                this.chatList.push({
                  sendTime: moment.parseZone(item.sendTime).format('YYYY-MM-DD HH:mm:ss'),
                  id: this.chatList.length + 1,
                  bot: true,
                  content: item.text
                });
                this.dbClient.MessageList.put(h5BotInfo);
              }
              if (item.image) {
                this.chatList.push({
                  sendTime: moment.parseZone(item.sendTime).format('YYYY-MM-DD HH:mm:ss'),
                  id: this.chatList.length + 1,
                  bot: true,
                  content: `<img src="${item.image.url}" alt="image" class="previewImage" ${scopeId} />`
                })
                this.dbClient.MessageList.put({
                  sendTime: moment.parseZone(item.sendTime).format('YYYY-MM-DD HH:mm:ss'),
                  sessionId: this.sessionId,
                  bot: true,
                  content: `<img src="${item.image.url}" alt="image" class="previewImage" ${scopeId} />`
                });
              }
              if (item.document || item.video) {
                const fileContent = item.document
                  ? `<a href="${item.document.url}" target="_blank">${item.document.name}</a>`
                  : `<video controls style="width: 100%" src="${item.video.url}">`
                this.chatList.push({
                  sendTime: moment.parseZone(item.sendTime).format('YYYY-MM-DD HH:mm:ss'),
                  id: this.chatList.length + 1,
                  bot: true,
                  content: fileContent
                })
                this.dbClient.MessageList.put({
                  sendTime: moment.parseZone(item.sendTime).format('YYYY-MM-DD HH:mm:ss'),
                  sessionId: this.sessionId,
                  bot: true,
                  content: fileContent
                });
              }
            })
            setTimeout(() => {
              this.scrollToBottom();
            }, 17)
          }
        })
    },
    async sendH5Message(h5MessageStr, firstFlag) {
      const messageBody = JSON.stringify({
        from: this.sessionId,
        name: this.userInfo.name,
        email: this.userInfo.email,
        phone: this.userInfo.mobile,
        messageId: uuid(),
        message: {
          text : h5MessageStr
        }
      })
      const header = await this.getHeaders(messageBody);
      fetch('/a2p/api/v1/chatbot-h5/inbound/receive', {
        method: 'POST',
        body: messageBody,
        headers: header
      })
        .then(res => {
          return res.json()
        })
        .then(res => {
          if (res.errorMessage) {
            this.$message.error(res.errorMessage);
            return;
          }
          if (firstFlag) {
            this.agentFlag = true;
          }
        })
    },
    async closeChatBotH5() {
      if (this.h5BtnDisable) {
        return;
      }
      this.h5BtnDisable = true;
      await this.addUserMessage(this.language === 'zh-CN' ? '结束人工' : 'End of live agent', 'bot');
      await this.sendH5Message('quit', false);
      this.h5BtnDisable = false;
      this.agentFlag = false;
    },
    async openChatBotH5() {
      if (this.h5BtnDisable) {
        return;
      }
      this.h5BtnDisable = true;
      await this.addUserMessage(this.language === 'zh-CN' ? '转人工' : 'Connect to live agent', 'bot');
      await this.sendH5Message('agent', true);
      this.h5BtnDisable = false
    },
    async generateSignature(appSecret, timestamp, messageBody) {
      const keyData = CryptoJS.enc.Utf8.parse(appSecret);
      // 将timestamp和messageBody连接后进行HMAC-SHA256签名
      const message = timestamp + messageBody;
      const signature = await CryptoJS.HmacSHA256(message, keyData);
      // 将签名结果转换为十六进制字符串
      return signature.toString(CryptoJS.enc.Hex);
    },
    async getHeaders(messageBody) {
      const appId = '999458444133580802';
      const appSecret = '2420c6be32b44737889b2d3c2a817591';
      const timestamp = new Date().getTime().toString();
      const signatureData = await this.generateSignature(appSecret, timestamp, messageBody);
      return {
        signature: signatureData,
        appid: appId,
        timestamp,
      }
    },
    getHtml(content) {
      return content && marked.parse(content)
    },
    initMarkedOptions() {
      const markedOptions = markedHighlight({
        langPrefix: 'hljs language-',
        highlight(code, lang) {
          const language = hljs.getLanguage(lang) ? lang : 'javascript';
          return hljs.highlight(code, { language }).value;
        },
      });
      marked.setOptions({
        mangle: false,
        headerIds: false,
      });
      marked.use({
        ...markedOptions,
      });
    },
    formSubmit(e) {
      e.preventDefault();
      if (this.inputValue === '') return;
      this.sendTextMessage();
    },
    refreshTime() {
      let newChatList = JSON.parse(JSON.stringify(this.chatList));
      this.chatList = newChatList.map((chat) => {
        if (chat.time) {
          return {
            ...chat,
            content: new Date().getTime()
          }
        } else {
          return chat;
        }
      })
    },
    getTimeShow(timeStr) {
      let nowDate = moment();
      let showStrDate = moment(timeStr);
      let str = moment(timeStr).format('YYYY-MM-DD HH:mm:ss');
      const daysDiff = nowDate.diff(showStrDate, 'days');
      const hoursDiff = nowDate.diff(showStrDate, 'hours');
      const minutesDiff = nowDate.diff(showStrDate, 'minutes');
      if (daysDiff === 1) {
        str = 'yesterday'
      }
      if (nowDate.isSame(showStrDate, 'day')) {
        if (hoursDiff < 1) {
          str = `${minutesDiff} minutes ago`
        } else {
          str = `${hoursDiff} hours ago`
        }
      }
      if (nowDate.isSame(showStrDate, 'hour')) {
        if (minutesDiff <= 0) {
          str = 'just now'
        } else {
          str = `${minutesDiff} minutes ago`
        }
      }
      return str;
    },
    async addUserMessage(messageStr, type, loadingFlag) {
      const scopeId = this.$options._scopeId;
      const userChatId = this.chatList.length + 1;
      const bobChatId = this.chatList.length + 2;
      const timeId = moment().format('YYYY-MM-DD HH:mm:ss');
      // 用户第一次发送/超过5分钟没有交互的话，那么需要加上日期提示
      if (!this.interactiveFlag) {
        this.chatList.push({
          id: timeId,
          time: timeId,
          content: ''
        })
        await this.dbClient.MessageList.put({
          sessionId: this.sessionId,
          bot: false,
          time: timeId,
          content: ''
        })
      }
      // 清除之前的超时定时器
      if (this.interactiveTime) {
        clearTimeout(this.interactiveTime);
      }
      this.chatList.push({
        id: userChatId,
        bot: false,
        content: messageStr
      })
      // 清空输入框
      this.inputValue = '';
      if (loadingFlag) {
        this.btnDisabled = true;
        this.chatList.push({
          id: bobChatId,
          bot: true,
          content: `<div class="loader" ${scopeId}></div>`
        })
      }
      setTimeout(() => {
        this.scrollToBottom();
      }, 0)
      this.interactiveFlag = true;
      this.interactiveTime = setTimeout(() => {
        this.interactiveFlag = false;
      }, 1000*60*5)
      await this.dbClient.MessageList.put({
        sessionId: this.sessionId,
        bot: false,
        content: messageStr
      })
      return bobChatId;
    },
    async sendTextMessage() {
      const sendMessage = this.inputValue;
      await this.addUserMessage(sendMessage, 'bot');
      await this.sendH5Message(sendMessage, false);
    },
    async getChatListFromIndexDB() {
      // 看看当前是否缓存有聊天记录
      const list = await this.dbClient.MessageList.toArray();
      this.chatList = list || [];
      let deviceId = localStorage.getItem('deviceId');
      if (!deviceId && list.length === 0) {
        deviceId = this.randomDeviceId();
        const welcomeMessage = `<div>Hello! How can I assist you today? If you have any questions about Synagie or its services, feel free to ask! </div>`;
        this.chatList.push({
          id: 1,
          bot: true,
          content: welcomeMessage
        })
        await this.dbClient.MessageList.put({
          sessionId: this.sessionId || this.randomDeviceId(),
          bot: true,
          content: welcomeMessage
        })
        // localStorage.setItem('deviceId', deviceId);
      }
      if (!deviceId && list.length > 0) {
        // 用户清除了id 但是还没有清除回话
        deviceId = list[list.length - 1].sessionId || this.randomDeviceId();
        localStorage.setItem('deviceId', deviceId);
      }
      this.sessionId = deviceId;
      setTimeout(() => {
        this.scrollToBottom();
      }, 0)
    }
  }
}
</script>

<template>
  <div class="he-tu-h5-chat-outer">
    <div class="chat-header">
      <img src="./bot.png" alt="">Synagie
    </div>
    <div class="chat-content" ref="scrollContainer">
      <div class="chat-list">
        <div :class="`${item.bot ? 'bot ' : ''}chat-item`" v-for="item in chatList" :key="item.id">
          <div v-if="item.time" style="text-align: center;width: 100%" :data-tiem="item.content">
            {{getTimeShow(item.time)}}
          </div>
          <template v-else>
            <div class="chat-item-image">
              <img :src="item.bot ? require('./bot.png') : require('./user.png')" alt="">
            </div>
            <div class="chat-item-content-outer">{{item.name}}
              <p
                v-if="userInfo.name"
                :style="{textAlign: item.bot ? 'left' : 'right'}"
              >
                {{item.bot ? 'Synagie Chat' : (userInfo.name || '')}}
              </p>
              <div class="chat-item-content" v-html="getHtml(item.content)"></div>
            </div>
          </template>
        </div>
      </div>
    </div>
    <div class="chat-extra-outer">
      <div class="chat-bot-h5-button" role="button" @click="openChatBotH5" v-if="!agentFlag">
        {{language === 'zh-CN' ? '转人工' : 'Connect to live agent'}}
      </div>
      <div class="chat-bot-h5-button" role="button" @click="closeChatBotH5" v-if="agentFlag">
        {{language === 'zh-CN' ? '结束人工' : 'End of live agent'}}
      </div>
    </div>
    <form action="#" @submit="formSubmit">
      <div class="send-outer">
        <input
          :placeholder="language === 'zh-CN' ? '请输入内容' : 'Please enter the content'"
          v-model="inputValue"
          class="el-input__inner innerInput"
        >
        </input>
        <el-button
          htmlType="button"
          :disabled="!inputValue || btnDisabled"
          class="send-btn"
          @click="sendTextMessage"
        >{{language === 'zh-CN' ? '发送' : 'Send'}}</el-button>
      </div>
    </form>
  </div>
</template>

<style scoped lang="less">
.previewImage {
  width: 200px;
  height: 200px;
}
.he-tu-h5-chat-outer {
  width: 100vw;
  height: 100vh;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  /deep/ p {
    margin: 0;
  }
  .chat-header {
    box-sizing: border-box;
    width: 100%;
    height: 48px;
    background: #072445;
    display: flex;
    align-items: center;
    padding: 0 16px;
    color: #fff;
    font-size: 18px;
    font-weight: 600;
    img {
      display: block;
      border-radius: 50%;
      width: 30px;
      height: 30px;
      margin-right: 5px;
    }
  }
  .chat-content {
    flex: 1;
    box-sizing: border-box;
    padding: 15px;
    overflow-y: auto;
    background: #f8f8f8;
    .chat-list {
      display: flex;
      flex-direction: column;
      .chat-item {
        margin-bottom: 10px;
        display: flex;
        flex-direction: row-reverse;
        &.bot {
          flex-direction: row;
          .chat-item-content {
            border-radius: 0 15px 15px 15px;
            color: #333;
            background: #eee;
            margin-left: 5px;
          }
          .chat-item-content-outer {
            align-items: flex-start;
            margin-left: 5px;
          }
        }
        .chat-item-image {
          img {
            width: 30px;
            height: 30px;
            border-radius: 50%;
          }
        }
        .chat-item-content-outer {
          margin-right: 5px;
          max-width: 82%;
          display: flex;
          flex-direction: column;
          align-items: flex-end;
        }
        .chat-item-content {
          word-break: break-word;
          box-sizing: border-box;
          padding: 8px 15px;
          background: #8b57ea;
          border-radius: 15px 0 15px 15px;
          color: #fff;
          font-weight: 500;
          font-size: 14px;
          text-align: left;
          margin-top: 10px;
          margin-right: 5px;
        }
      }
    }
  }
  .chat-extra-outer {
    padding: 10px 4px 0 12px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    background: #eee;
    overflow-x: auto;
    width: 100%;
    box-sizing: border-box;
    .chat-bot-h5-button {
      padding: 4px 16px;
      border-radius: 20px;
      background: #fff;
      font-size: 14px;
    }
  }
  .send-outer {
    width: 100%;
    box-sizing: border-box;
    height: 60px;
    display: flex;
    align-items: center;
    padding: 10px;
    background: #eee;
    .send-btn {
      height: 40px;
      padding: 8px;
      background-color: #f3f3f3;
      border-radius: 0 4px 4px 0;
      border: 1px solid #dcdfe6;
    }
  }
}

.loader {
  width: 30px;
  aspect-ratio: 2;
  --_g: no-repeat radial-gradient(circle closest-side,#000 90%,#0000);
  background:
    var(--_g) 0%   50%,
    var(--_g) 50%  50%,
    var(--_g) 100% 50%;
  background-size: calc(100%/3) 50%;
  animation: l3 1s infinite linear;
}
@keyframes l3 {
  20%{background-position:0%   0%, 50%  50%,100%  50%}
  40%{background-position:0% 100%, 50%   0%,100%  50%}
  60%{background-position:0%  50%, 50% 100%,100%   0%}
  80%{background-position:0%  50%, 50%  50%,100% 100%}
}
</style>



// WEBPACK FOOTER //
// src/synagieChat/newIndex.vue